import React, { useState } from 'react';
import Frame from '../images/Frame.svg';
import ContactPopup from './Popup';
import { SparklesIcon, UserGroupIcon, TrophyIcon } from '@heroicons/react/24/outline';

function Decision() {
  const [isOpen, setIsOpen] = useState(false);
  
  const openPopup = () => {
    setIsOpen(true)
  }
  
  const updateBoollen = (value) => {
    setIsOpen(value)
  }

  const features = [
    {
      icon: UserGroupIcon,
      title: "Join Our Community",
      description: "Connect with passionate runners from all backgrounds"
    },
    {
      icon: TrophyIcon,
      title: "Achieve Your Goals",
      description: "Set and reach new personal milestones together"
    },
    {
      icon: SparklesIcon,
      title: "Make a Difference",
      description: "Participate in events that support meaningful causes"
    }
  ];

  return (
    <section className="bg-gradient-to-br from-primary-50 to-secondary-50 relative overflow-hidden py-[5px]">
      {/* Background Decorative Elements */}
      <div className="absolute top-0 right-0 w-64 h-64 bg-primary-500/5 rounded-full translate-x-32 -translate-y-32"></div>
      <div className="absolute bottom-0 left-0 w-96 h-96 bg-secondary-500/5 rounded-full -translate-x-48 translate-y-48"></div>
      
      <div className="container-custom relative">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 lg:gap-16 items-center">
          
          {/* Content Section */}
          <div className="space-y-8 animate-slide-in-left">
            <div className="space-y-6">
              <div className="inline-flex items-center space-x-2 bg-primary-100 text-primary-700 px-4 py-2 rounded-full text-sm font-semibold">
                <SparklesIcon className="w-4 h-4" />
                <span>Join the Movement</span>
              </div>
              
              <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gradient-primary leading-tight">
                Start Your Running Journey Today!
              </h2>
              
              <p className="text-xl md:text-1xl text-neutral-500 leading-relaxed">
                People everywhere are empowered to start their fitness journey, mobilize supporters, 
                and work with our community to achieve extraordinary goals together.
              </p>
            </div>
            
            {/* Features Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-6">
              {features.map((feature, index) => (
                <div 
                  key={index} 
                  className="text-center space-y-3 animate-slide-up"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <div className="w-12 h-12 bg-primary-100 rounded-xl flex items-center justify-center mx-auto group-hover:bg-primary-200 transition-colors">
                    <feature.icon className="w-6 h-6 text-primary-600" />
                  </div>
                  <h3 className="font-semibold text-neutral-900">{feature.title}</h3>
                  <p className="text-sm text-neutral-600">{feature.description}</p>
                </div>
              ))}
            </div>
            
            {/* CTA Buttons */}
            <div className="flex flex-col sm:flex-row gap-4 pt-4">
              <button 
                className="relative overflow-hidden bg-transparent border-2 border-primary-500 text-primary-600 hover:bg-primary-500 hover:text-white font-semibold px-8 py-4 rounded-xl transition-all duration-300 hover:shadow-glow-primary hover:scale-105"
                onClick={openPopup}
              >
                Contact Us
              </button>
              <button className="btn-outline text-lg px-8 py-4">
                Learn More
              </button>
            </div>
            
            {/* Stats */}
            <div className="grid grid-cols-3 gap-6 pt-8 border-t border-neutral-200">
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-primary-600">500+</div>
                <div className="text-sm text-neutral-600">Active Members</div>
              </div>
              <div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-secondary-600">2</div>
                <div className="text-sm text-neutral-600">Events Completed</div>
              </div>
              {/*<div className="text-center">
                <div className="text-2xl md:text-3xl font-bold text-accent-600">₹10L+</div>
                <div className="text-sm text-neutral-600">Funds Raised</div>
              </div>*/}
            </div>
          </div>
          
          {/* Image Section */}
          <div className="relative animate-slide-in-right">
            <div className="relative">
              {/* Decorative background shapes */}
              <div className="absolute -top-8 -right-8 w-24 h-24 bg-primary-200 rounded-full opacity-60 animate-float"></div>
              <div className="absolute -bottom-8 -left-8 w-32 h-32 bg-secondary-200 rounded-full opacity-60 animate-float animation-delay-300"></div>
              
              {/* Main image container */}
              <div className="relative bg-white rounded-3xl p-8 shadow-strong">
                <img 
                  src={Frame} 
                  alt="Running Community Illustration" 
                  className="w-full h-auto max-w-md mx-auto drop-shadow-lg" 
                />
                
                {/* Floating cards */}
                <div className="absolute -top-4 -left-4 bg-primary-500 text-white p-3 rounded-xl shadow-medium animate-bounce-gentle">
                  <TrophyIcon className="w-6 h-6" />
                </div>
                
                <div className="absolute -bottom-4 -right-4 bg-secondary-500 text-white p-3 rounded-xl shadow-medium animate-bounce-gentle animation-delay-500">
                  <UserGroupIcon className="w-6 h-6" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <ContactPopup popup={isOpen} updateValue={(value) => updateBoollen(value)} />
    </section>
  )
}

export default Decision;